import { UntypedFormControl } from '@angular/forms';

export const nameErrorHandler = (
  control: UntypedFormControl,
  label: string
): String => {
  if (control.hasError('required') || control.hasError('notblank')) {
    return `Please enter ${label}`;
  }
  if (control.hasError('maxlength')) {
    const max = control.getError('maxlength').requiredLength;
    return `Must not exceed ${max} characters`;
  }
  return 'Please enter a valid name';
};
